<template>
  <div class="recruit">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/contactUs' }">{{ $t('contactUs.breadcrumbContact') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('contactUs.breadcrumbRecruit') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="recruit-content">
      <jobInformation1 v-if="type === '0'"></jobInformation1>
      <jobInformation2 v-if="type === '1'"></jobInformation2>
      <jobInformation3 v-if="type === '2'"></jobInformation3>
      <jobInformation4 v-if="type === '3'"></jobInformation4>
      <jobInformation5 v-if="type === '4'"></jobInformation5>
      <jobInformation6 v-if="type === '5'"></jobInformation6>
      <div class="gotop" @click="goToTop"><img :src="goTop"></div>
    </div>
  </div>
</template>

<script>
import jobInformation1 from './components/jobInformation1.vue'
import jobInformation2 from './components/jobInformation2.vue'
import jobInformation3 from './components/jobInformation3.vue'
import jobInformation4 from './components/jobInformation4.vue'
import jobInformation5 from './components/jobInformation5.vue'
import jobInformation6 from './components/jobInformation6.vue'
export default {
  data () {
    return {
      type: this.$route.query.index,
      goTop: require('@/assets/images2/gotop.png'),
    }
  },
  components: {
    jobInformation1,
    jobInformation2,
    jobInformation3,
    jobInformation4,
    jobInformation5,
    jobInformation6
  },
  methods: {
    goToTop() {
      // 平滑滚动到页面顶部
      // window.scrollTo({
      //   top: 0,
      //   behavior: 'smooth'
      // });
      // 兼容性更好的方法，如果上面的方法不工作，可以使用下面的方法
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.recruit {
  padding-top: 60px;
  margin: 0 auto;
  background-color: rgb(248, 250, 253);
  overflow: hidden;
  ::v-deep .el-breadcrumb {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
  }
  .recruit-content {
    box-sizing: border-box;
    width: 1200px;
    padding: 60px;
    margin: 0 auto;
    background-color: #fff;
    margin-bottom: 100px;
    position: relative;
    .gotop {
      position: absolute;
      right: -60px;
      bottom: 20px;
      width: 60px;
      height: 60px;
      cursor: pointer;
    }
  }
}
</style>